<template>
  <div class="GuestInfo" v-if="show" :class="{ loading: loading > 0 }">
    <h2 v-if="viewOrder" class="title">
      <span v-if="items && items.length" v-html="tran('VIEW_ORDER_TITLE', {
        firstName: guests[0]?.guests[0]?.firstName ?? '',
        lastName: guests[0]?.guests[0]?.lastName ?? '',
      })
        "></span>
    </h2>
    <h2 v-else class="title">{{ tran("GUEST_INFO_TITLE") }}</h2>
    <!-- Vaccination -->

    <div class="guest-info">
      <div class="guests" v-if="guests.length && items">
        <div v-if="vaccination" class="survey-box vaccination" :class="{
          'vaccination-yes': userVaccination == 'yes',
          'vaccination-no': userVaccination == 'no',
        }">
          <div class="survey-header" v-html="vaccination.title"></div>
          <div class="survey-body">
            <div v-if="userVaccination == ''" v-html="vaccination.question"></div>
            <div v-if="userVaccination == 'yes'" v-html="vaccination.answer_yes"></div>
            <div v-if="userVaccination == 'no'" v-html="vaccination.answer_no"></div>
          </div>
          <div class="survey-bottom" v-if="run('get', 'vaccination', '') == ''">
            <button id="vaccination-yes-btn" @click.prevent="setVaccination('yes')" v-html="tran('YES')"
              class="btn btn-primary-outline"></button>
            <button id="vaccination-no-btn" @click.prevent="setVaccination('no')" v-html="tran('NO')"
              class="btn btn-primary-outline"></button>
          </div>
        </div>
        <div class="guest item" v-for="(roomGuests, roomIndex) in guests" :key="roomIndex" ref="guests">
          <div class="guest-room">
            <h4 v-if="guests.length > 1" v-html="tran('ROOM_INDEX', { room: roomIndex + 1 })"></h4>
            <h4 v-else></h4>
            <div v-html="tran(
              'ROOM_GUEST_NUMBER' +
              (userRooms[roomIndex].numberOfChildren > 0
                ? '_CHILDREN'
                : ''),
              {
                numberOfAdults: userRooms[roomIndex].numberOfAdults,
                numberOfChildren: userRooms[roomIndex].numberOfChildren,
              }
            )
              "></div>
          </div>
          <div class="guest item" v-for="(guest, index) in roomGuests.guests" :key="index" :class="{
            active: hadVaccination && guest.active,
            complete: guest.complete,
            disabled: !hadVaccination,
          }">
            <div class="guest-form">
              <h3 @click="showForm(guest)">
                <span v-if="index == 0" v-html="tran('PRIMARY_GUEST')"></span>
                <span v-else-if="guest.type == 'adult'" v-html="tran('GUEST_ADULT_INDEX', { no: guest.no })"></span>
                <span v-else-if="guest.type == 'child'" v-html="tran('GUEST_CHILD_INDEX', { no: guest.no })"></span>
              </h3>
              <div class="wrapper">
                <h4><span v-html="tran('PERSONAL_INFOMATION')"></span></h4>
                <div class="row">
                  <div class="col-sm-3">
                    <div class="form-group floating-label">
                      <label :for="'guestFirstName' + roomIndex + '-' + index"><span
                          v-text="tran('GUEST_TITLE')"></span></label>
                      <vSelect :reduce="reduceValue" :options="titles" v-model="guest.title" :clearable="false" class=""
                        :placeholder="tran('SELECT')" label="title" :disabled="readOnly" @update:modelValue="
                          () => onchangeTitle(index, roomIndex)
                        ">
                        <template #no-options=""><span v-html="tran('SELECT_NO_OPTION_MATCH')"></span></template>
                      </vSelect>
                      <span class="error" v-if="
                        errors[roomIndex + '-' + index] &&
                        errors[roomIndex + '-' + index]['title']
                      " v-text="errors[roomIndex + '-' + index]['title']"></span>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="form-group floating-label">
                      <input :id="'guestFirstName' + roomIndex + '-' + index" class="form-control" type="text"
                        :placeholder="tran('FIRST_NAME')" :value="guest.firstName" :readonly="readOnly" @change="
                          (e) =>
                            changeInput(
                              e.target.value,
                              index,
                              roomIndex,
                              'firstName'
                            )
                        " />
                      <label :for="'guestFirstName' + roomIndex + '-' + index"><span
                          v-text="tran('FIRST_NAME')"></span></label>
                      <span class="error" v-if="
                        errors[roomIndex + '-' + index] &&
                        errors[roomIndex + '-' + index]['firstName']
                      " v-text="errors[roomIndex + '-' + index]['firstName']"></span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group floating-label">
                      <input :id="'guestLastName' + roomIndex + '-' + index" class="form-control" type="text"
                        :placeholder="tran('LAST_NAME')" :value="guest.lastName" :readonly="readOnly" @change="
                          (e) =>
                            changeInput(
                              e.target.value,
                              index,
                              roomIndex,
                              'lastName'
                            )
                        " />
                      <label :for="'guestLastName' + roomIndex + '-' + index"><span
                          v-text="tran('LAST_NAME')"></span></label>
                      <span class="error" v-if="
                        errors[roomIndex + '-' + index] &&
                        errors[roomIndex + '-' + index]['lastName']
                      " v-text="errors[roomIndex + '-' + index]['lastName']"></span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group floating-label">
                      <label><span v-text="tran('BIRTHDAY')"></span></label>
                      <div class="birthday">
                        <vSelect append-to-body :options="months[roomIndex + '-' + index]" :clearable="false" class=""
                          :placeholder="tran('MONTH')" label="title" :reduce="reduceValue" v-model="guest.birthdayMonth"
                          @close="() => setDays(index, roomIndex)" :disabled="readOnly" @update:modelValue="
                            (e) => changeSelect(index, roomIndex, 'birthday')
                          ">
                          <template #no-options=""><span v-html="tran('SELECT_NO_OPTION_MATCH')"></span></template>
                        </vSelect>
                        <vSelect append-to-body :options="days[roomIndex + '-' + index]" :clearable="false" class=""
                          :placeholder="tran('DAY')" label="title" :reduce="reduceValue" v-model="guest.birthdayDay"
                          :disabled="readOnly" @update:modelValue="
                            (e) => changeSelect(index, roomIndex, 'birthday')
                          ">
                          <template #no-options=""><span v-html="tran('SELECT_NO_OPTION_MATCH')"></span></template>
                        </vSelect>
                        <vSelect append-to-body :options="years[roomIndex + '-' + index]" :clearable="false" class=""
                          :placeholder="tran('YEAR')" label="title" :reduce="reduceValue" v-model="guest.birthdayYear"
                          :disabled="readOnly" @update:modelValue="
                            (e) => changeSelect(index, roomIndex, 'birthday')
                          ">
                          <template #no-options=""><span v-html="tran('SELECT_NO_OPTION_MATCH')"></span></template>
                        </vSelect>
                      </div>
                      <span class="error" v-if="
                        errors[roomIndex + '-' + index] &&
                        errors[roomIndex + '-' + index]['birthday']
                      " v-text="errors[roomIndex + '-' + index]['birthday']"></span>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group floating-label">
                      <label class="options-label" :for="'guestFirstName' + roomIndex + '-' + index"><span
                          v-text="tran('GENDER')"></span></label>
                      <div class="options">
                        <input :id="'genderMale' + roomIndex + '-' + index" type="radio" v-model="guest.gender"
                          value="male" :disabled="readOnly" />
                        <label :disabled="readOnly" :for="'genderMale' + roomIndex + '-' + index"><span
                            v-html="tran('MALE')"></span></label>
                        <input :id="'genderFemale' + roomIndex + '-' + index" type="radio" v-model="guest.gender"
                          value="female" :disabled="readOnly" />
                        <label :disabled="readOnly" :for="'genderFemale' + roomIndex + '-' + index"><span
                            v-html="tran('FEMALE')"></span></label>
                      </div>
                      <span class="error" v-if="
                        errors[roomIndex + '-' + index] &&
                        errors[roomIndex + '-' + index]['gender']
                      " v-text="errors[roomIndex + '-' + index]['gender']"></span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group floating-label">
                      <label :for="'guestFirstName' + roomIndex + '-' + index"><span
                          v-text="tran('CITIZENSHIP')"></span></label>
                      <vSelect append-to-body :reduce="reduceValue" :options="cititzenships" v-model="guest.citizenship"
                        :clearable="false" class="" :placeholder="tran('SELECT')" label="title" :disabled="readOnly"
                        @update:modelValue="
                          (e) => changeSelect(index, roomIndex, 'citizenship')
                        ">
                        <template #no-options=""><span v-html="tran('SELECT_NO_OPTION_MATCH')"></span></template>
                        <template #option="{ title }">
                          <span>{{ title }}</span>
                        </template>
                      </vSelect>
                      <span class="error" v-if="
                        errors[roomIndex + '-' + index] &&
                        errors[roomIndex + '-' + index]['citizenship']
                      " v-text="errors[roomIndex + '-' + index]['citizenship']"></span>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group floating-label">
                      <input :id="'guestClubNo' + roomIndex + '-' + index" class="form-control" type="text"
                        v-model="guest.clubNo" :readonly="readOnly" />
                      <label :for="'guestClubNo' + roomIndex + '-' + index"><span
                          v-text="tran('CAPTAIN_CLUB_NO')"></span></label>
                    </div>
                  </div>
                </div>
                <h4 v-if="index == 0">
                  <span v-html="tran('CONTACT_INFORMATION')"></span>
                </h4>

                <div class="row" v-if="index == 0">
                  <div class="col-sm-6">
                    <div class="form-group floating-label">
                      <label :for="'guestPhone' + roomIndex + '-' + index"><span
                          v-text="tran('PHONE_NUMBER')"></span></label>
                      <div class="field-group">
                        <vSelect :options="phoneCodes" v-model="guest.phoneCode" :clearable="false" class=""
                          label="value" :disabled="readOnly" :reduce="reduceValue" append-to-body
                          :calculate-position="withPopper" @update:modelValue="
                            (e) => changeSelect(index, roomIndex, 'phoneCode')
                          ">
                          <template #no-options=""><span v-html="tran('SELECT_NO_OPTION_MATCH')"></span></template>
                          <template #option="{ value }">
                            ({{ value }})
                          </template>
                          <template #selected-option="{ value }">
                            ({{ value }})
                          </template>
                        </vSelect>
                        <input :id="'guestPhone' + roomIndex + '-' + index" class="form-control" type="text"
                          :placeholder="tran('PHONE_NUMBER')" :value="guest.phoneNumber" :readonly="readOnly" @change="
                            (e) =>
                              changeInput(
                                e.target.value,
                                index,
                                roomIndex,
                                'phoneNumber'
                              )
                          " />
                      </div>

                      <span class="error" v-if="
                        errors[roomIndex + '-' + index] &&
                        errors[roomIndex + '-' + index]['phone']
                      " v-text="errors[roomIndex + '-' + index]['phone']"></span>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group floating-label">
                      <input :id="'guestEmail' + roomIndex + '-' + index" class="form-control" type="text"
                        :placeholder="tran('EMAIL_ADDRESS')" :value="guest.email" :readonly="readOnly" @change="
                          (e) =>
                            changeInput(
                              e.target.value,
                              index,
                              roomIndex,
                              'email'
                            )
                        " />
                      <label :for="'guestEmail' + roomIndex + '-' + index"><span
                          v-text="tran('EMAIL_ADDRESS')"></span></label>
                      <span class="error" v-if="
                        errors[roomIndex + '-' + index] &&
                        errors[roomIndex + '-' + index]['email']
                      " v-text="errors[roomIndex + '-' + index]['email']"></span>
                      <span v-else-if="roomIndex == 0 && index == 0" class="note"
                        v-text="tran('BOOKING_EMAIL_NOTE')"></span>
                    </div>
                  </div>
                </div>

                <div class="row row-fcc">
                  <div class="col-sm-12">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" value="1" v-model="guest.fcc"
                          :disabled="readOnly" /><span v-html="tran('HAVE_FCC')"></span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="buttons" v-if="!viewOrder && index == roomGuests.guests.length - 1">
                  <button id="next-guest-button" v-if="nextRoomButton(roomIndex)" type="button" class="btn btn-success"
                    @click.prevent="nextGuest(roomIndex)" :disabled="loading > 0 ? '' : null">
                    {{ tran("CONTINUE_NEXT_ROOM") }}
                  </button>
                  <button id="confirm-to-pay" v-else type="button" class="btn btn-success"
                    @click.prevent="nextGuest(roomIndex)" :disabled="loading > 0 ? '' : null">
                    {{ tran("CONTINUE_PAYMENT") }}
                  </button>
                </div>
                <div v-if="false" class="note" v-html="tran('GUEST_INPUT_INFORMATION_NOTE')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rooms" v-if="items">
        <div class="room item" v-for="(item, index) in items" :key="index"
          :class="{ hideSummary: !rooms[index] || rooms[index].hideSummary }">
          <div class="wrapper">
            <div class="image">
              <img v-if="item.image" :src="item.image" />
              <div v-if="viewOrder" class="booking-id">
                <span v-html="tran('BOOKING_ID', { bookingId: item.bookingId })"></span>
              </div>
              <div class="info">
                <h4 class="title" v-html="item.title"></h4>
                <div class="location" v-html="item.location"></div>
              </div>
            </div>
            <div class="desc" v-html="item.detail"></div>
            <div class="buttons">
              <a v-if="!rooms[index] || rooms[index].hideSummary" @click.prevent="hideSummary(index)"
                class="pointer"><span v-html="tran('VIEW_VACATION_SUMMARY')"></span></a>
              <a v-else @click.prevent="hideSummary(index)" class="pointer"><span
                  v-html="tran('HIDE_VACATION_SUMMARY')"></span></a>
            </div>
          </div>
        </div>

        <div class="trip-totals" v-if="userRooms.length > 1" v-html="totalDetail"></div>
        <div class="pay-amount" v-if="!viewOrder">
          <h4 v-html="tran('HOW_MUCH_PAY')"></h4>
          <div class="pay-options">
            <div class="pay-option" :class="{ active: !payAll }" @click="payAll = false" v-if="amount_deposit">
              <span v-html="tran('PAY_DEPOSIT_DUE')"></span>
              <span v-html="amount_deposit"></span>
            </div>
            <div class="pay-option" :class="{ active: payAll }" @click="payAll = true">
              <span v-html="tran('PAY_CRUISE_TOTAL')"></span>
              <span v-html="amount_total"></span>
            </div>
          </div>
        </div>
        <div class="payment-methods" :class="{ hidden: !paymentMethods || paymentMethods.length <= 1 }">
          <h4 v-html="tran('PAYMENT_METHODS')"></h4>
          <div v-for="(method, index) in paymentMethods" :key="index" @click.prevent="paymentMethod = method"
            class="payment-method" :class="{ selected: method.code == paymentMethod?.code }">
            <span v-if="method.logo" v-html="method.logo"></span><span v-html="method.title"></span>
          </div>
        </div>
        <div v-if="paymentMethod && paymentMethod.info" class="support-payment-methods">
          <h4 v-html="tran('SUPPORT_PAYMENT_METHODS')"></h4>
          <div v-html="paymentMethod.info"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import phoneCodes from "../assets/phone-code.json";
import { createPopper } from "@popperjs/core";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "GuestInfo",
  components: { vSelect },
  props: {
    run: Function,
  },
  data: function () {
    return {
      loading: 0,
      items: false,
      totalDetail: "",
      currentMonth: "",
      currentYear: "",
      cititzenships: [],
      titles: [],
      errors: {},
      rooms: { 0: { hideSummary: false } },
      days: {},
      months: {},
      years: {},
      paymentMethod: false,
      vaccination: false,
      phoneCodes: phoneCodes,
      amount_deposit: "",
      amount_total: "",
      payAll: false,
      // guests: [],
    };
  },
  created() { },
  mounted: function () {
    this.run("set", "groupStep." + this.$.type.name, "review_pay");
    if (typeof this.validate == "function") {
      this.run("set", "validates." + this.$.type.name, this.validate);
    }
    if (typeof this.next == "function") {
      this.run("set", "nexts." + this.$.type.name, this.next);
    }
    if (typeof this.prev == "function") {
      this.run("set", "prevs." + this.$.type.name, this.prev);
    }
    if (this.show) {
      this.onShow();
    }
    this.fetchTitles();
    this.fetchCititzenships();
    this.repairPhone();
  },
  watch: {
    show: function (n) {
      if (n) {
        this.onShow();
      } else {
        this.onHide();
      }
    },
    // guests: function () {
    //   console.log("a");
    // },
  },

  computed: {
    show: function () {
      return (
        this.run("viewOrder") || this.run("currentStep") == this.$.type.name
      );
    },
    data() {
      return this.run("data");
    },
    currentUserRoomIndex() {
      return this.run("currentUserRoomIndex");
    },
    userRooms() {
      return this.run("rooms");
    },
    guests() {
      return this.run("guests");
    },
    viewOrder() {
      return this.run("viewOrder");
    },
    readOnly() {
      return this.viewOrder == true ? "" : undefined;
    },
    paymentMethods() {
      return this.run("paymentMethods");
    },
    userVaccination() {
      return this.run("get", "vaccination", "");
    },
    hadVaccination() {
      return !this.vaccination || this.userVaccination != "";
    },

    // days() {
    //   const date = new Date(this.currentYear, this.currentMonth);
    //   const days = new Date(
    //     date.getFullYear(),
    //     date.getMonth() + 1,
    //     0
    //   ).getDate();
    //   return Array.from(
    //     { length: days },
    //     (x, i) => (i > 9 ? "" : "0") + (i + 1)
    //   );
    // },
    // months() {
    //   return Array.from({ length: 12 }, (x, i) => ({
    //     value: i + 1,
    //     title: this.tran("MONTH_" + (i + 1)),
    //   }));
    // },
    // years() {
    //   const currentYear = new Date().getFullYear();
    //   return Array.from({ length: 110 }, (x, i) => currentYear - i);
    // },
  },
  methods: {
    repairPhone() {
      if (!this.guests) {
        return;
      }
      for (const roomGuests of this.guests) {
        if (!roomGuests || !Array.isArray(roomGuests)) {
          continue;
        }
        for (const guest of roomGuests) {
          if (guest.phone) {
            guest.phone = guest.phone
              .replace("(", "")
              .replace(")", "")
              .replace("+", "");
          }
          if (guest.phone && !guest.phoneCode) {
            guest.phoneCode = this.findPhoneCode(guest.phone);
          }
          if (guest.phoneCode == "") {
            guest.phoneCode = "852";
          }

          if (
            guest.phoneCode != "" &&
            guest.phone &&
            guest.phone.startsWith(guest.phoneCode)
          ) {
            guest.phoneNumber = guest.phone
              .slice(guest.phoneCode.length)
              .trim();
          }
        }
      }
    },
    findPhoneCode(phone) {
      const phoneCodes = JSON.parse(JSON.stringify(this.phoneCodes));
      phoneCodes.sort((a, b) =>
        a.value.length < b.value.length
          ? 1
          : a.value.length > b.value.length
            ? -1
            : 0
      );
      for (const code of this.phoneCodes) {
        if (phone.startsWith(code.value)) {
          return code.value;
        }
      }
      return "";
    },
    nextRoomButton(index) {
      if (this.guests.length == 1) {
        return false;
      }
      let complete = 0;
      for (const guestRoom of this.guests) {
        if (guestRoom.complete) {
          complete++;
        }
      }
      if (
        complete == this.guests.length ||
        (complete == this.guests.length - 1 && !this.guests[index].complete)
      ) {
        return false;
      }
      return true;
    },
    setDays(index, roomIndex) {
      const date = new Date(
        this.guests[roomIndex].guests[index].birthdayYear,
        this.guests[roomIndex].guests[index].birthdayMonth - 1
      );
      const days = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0
      ).getDate();
      this.days[roomIndex + "-" + index] = Array.from(
        { length: days },
        (x, i) => ({
          value: i + 1,
          title: this.tran("DATE", { date: i + 1 }),
        })
      );
    },
    setMonths(index, roomIndex) {
      if (typeof this.months[index] != "undefined") {
        return;
      }
      this.months[roomIndex + "-" + index] = Array.from(
        { length: 12 },
        (x, i) => ({
          value: i + 1,
          title: this.tran("MONTH_" + (i + 1)),
        })
      );
    },
    setYears(index, roomIndex) {
      if (typeof this.years[index] != "undefined") {
        return;
      }
      const currentYear = new Date().getFullYear();
      this.years[roomIndex + "-" + index] = Array.from(
        { length: 110 },
        (x, i) => ({
          value: currentYear - i,
          title: this.tran("YEAR_DEFAULT", { year: currentYear - i }),
        })
      );
    },
    async fetchCititzenships() {
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
        this.run("get", "config.task", "booking") +
        ".citizenships"
      );
      this.cititzenships = res.items;
    },
    async fetchTitles() {
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
        this.run("get", "config.task", "booking") +
        ".getTitles"
      );
      this.titles = res.items;
    },
    reduceValue(item) {
      return item.value;
    },

    tran: function (key, replaces) {
      return this.run("tran", key, replaces);
    },
    onShow: function () {
      if (this.viewOrder) {
        this.fetchBooking();
        return;
      }
      // this.guests = JSON.parse(JSON.stringify(this.run("get", "guests")));
      let active = true;
      for (const roomIndex in this.guests) {
        for (const index in this.guests[roomIndex].guests) {
          this.guests[roomIndex].guests[index].active = active;
          this.setDays(index, roomIndex);
          this.setMonths(index, roomIndex);
          this.setYears(index, roomIndex);
        }
        active = false;
      }
      this.fetch();
      this.getPaymentMethods();
    },
    onHide: function () {
      this.run("set", "guests", JSON.parse(JSON.stringify(this.guests)));
    },
    async holdCabins() {
      this.loading++;
      const rooms = this.run("rooms");
      const ship = this.run("ship");
      // const numberOfRoom = this.run("numberOfRoom");
      // const promotionCode = this.run("promotionCode");
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
        this.run("get", "config.task", "booking") +
        ".cabinHold",
        {
          rooms,
          shipCode: ship.shipCode,
          packageId: ship.packageId,
          sailDate: ship.sailDate,
        }
      );
      if (res.data && res.data.rooms) {
        this.run("set", "rooms", res.data.rooms);
      }
      if (res.success) {
        this.loading--;
        return true;
      }
      this.run("showMessage", res.message ?? "error", res.messageType);
      setTimeout(
        () => this.run("goStep", this.run("stepIndex", "RoomChoose")),
        200
      );

      this.loading--;
      return false;
    },
    async fetchBooking() {
      this.loading++;
      const orderId = this.run("orderId");
      const orderCode = this.run("orderCode");
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
        this.run("get", "config.task", "booking") +
        ".getOrder",
        { orderId, orderCode }
      );
      if (!res.success) {
        this.run("showMessage", res.message ?? "error", res.messageType);
        this.loading--;
        return;
      }
      this.items = res.data.items;
      this.totalDetail = res.data.total;
      if (res.data.guests.length > res.data.rooms.length) {
        res.data.guests = res.data.guests.slice(0, res.data.rooms.length);
      }
      this.run("set", "guests", res.data.guests);
      this.run("set", "rooms", res.data.rooms);
      this.loading--;
      let active = true;
      for (const roomIndex in this.guests) {
        for (const index in this.guests[roomIndex].guests) {
          this.guests[roomIndex].guests[index].active = active;
          this.setDays(index, roomIndex);
          this.setMonths(index, roomIndex);
          this.setYears(index, roomIndex);
        }
        active = false;
      }
    },
    async fetch(checkSenior) {
      this.loading++;
      let rooms = this.run("rooms");
      if (checkSenior) {
        rooms = JSON.parse(JSON.stringify(rooms));
        for (const k in rooms) {
          const room = rooms[k];
          room.senior = this.hasSenior(this.guests[k] ?? false) ? 1 : 0;
        }
      }
      const numberOfRoom = this.run("numberOfRoom");
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
        this.run("get", "config.task", "booking") +
        ".getGuests",
        { rooms, numberOfRoom }
      );
      if (!res.success) {
        this.run("showMessage", res.message ?? "error", res.messageType);
        this.loading--;
        return;
      }
      this.items = res.data.items;
      this.totalDetail = res.data.total;
      this.vaccination = res.data.vaccination;
      this.amount_deposit = res.data.amount_deposit;
      this.amount_total = res.data.amount_total;
      if (!this.amount_deposit) {
        this.payAll = true;
      }
      this.run("set", "summaries", res.data);
      this.loading--;
    },

    async getPaymentMethods() {
      this.loading++;
      const rooms = this.run("rooms");
      const numberOfRoom = this.run("numberOfRoom");
      const promotionCode = this.run("promotionCode");
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
        this.run("get", "config.task", "booking") +
        ".getPaymentMethods",
        { rooms, numberOfRoom, promotionCode, guests: this.guests }
      );
      if (!res.success) {
        this.run("showMessage", res.message ?? "error", res.messageType);
        this.loading--;
        return;
      }
      this.run("set", "paymentMethods", res.data);
      let paymentMethod = false;
      for (const method of res.data) {
        if (
          (this.paymentMethod && this.paymentMethod.code == method.code) ||
          !paymentMethod
        ) {
          paymentMethod = method;
        }
      }
      this.paymentMethod = paymentMethod;

      this.loading--;
    },
    select(item) {
      this.run(
        "set",
        "rooms." + this.currentUserRoomIndex + ".offer",
        item.value
      );

      this.run("next");
    },
    async checkSenior() {
      if (!this.run("get", "config.senior", false)) {
        return true;
      }
      for (const k in this.userRooms) {
        const room = this.userRooms[k];
        let hasSenior = this.hasSenior(this.guests[k] ?? false);
        if (room.senior && !hasSenior) {
          this.run("popupAlert", this.tran("AGE_SENIOR_BUT_54_OR_BELOW_MESSAGE"), [
            {
              label: this.tran("CONFIRM"),
              class: "btn-warning",
              action: () => {
                this.changeSenior()
              },
            },
          ]);
          return false;
        }
        if (!room.senior && hasSenior) {
          // const amount_total = this.amount_total;
          // if ((await this.fetch(true)) != amount_total) {
          this.run("popupAlert", this.tran("NOT_SENIOR_BUT_AGE_55_OR_ABOVE_MESSAGE"), [
            {
              label: this.tran("BOOKING_PAYMENT_YES"),
              class: "btn-success",
              action: () => {
                this.changeSenior()
              },
            },
            {
              label: this.tran("BOOKING_PAYMENT_NO"),
              class: "btn-warning",
              action: () => {
                this.next(true);
              },
            },
          ]);
          return false;
          // }
        }
      }
      return true;
    },
    async next(notCheckSenior) {
      this.loading++;
      // await this.holdCabins();

      if (!notCheckSenior && !(await this.checkSenior())) {
        this.loading--;
        return false;
      }

      this.run(
        "submit",
        this.paymentMethod.url
          ? this.paymentMethod.url
          : this.run("get", "paymentUrl"),
        {
          paymentMethod: this.paymentMethod.code,
          ...(this.paymentMethod.form ?? {}),
          guests: JSON.stringify(this.guests),
          rooms: JSON.stringify(this.userRooms),
          payAll: this.payAll,
        }
      );
      this.loading--;

      return false;
      // this.loading++;
      // await this.getPaymentMethods();
      // const paymentMethods = this.run("get", "paymentMethods");
      // if (paymentMethods.length == 1 && !paymentMethods[0].creditCard) {
      //   this.run(
      //     "submit",
      //     paymentMethods[0].url
      //       ? paymentMethods[0].url
      //       : this.run("get", "paymentUrl"),
      //     { paymentMethod: paymentMethods[0].code, ...paymentMethods[0].form??{} }
      //   );
      //   this.loading--;
      //   return false;
      // }
      // this.loading--;
      // return true;
    },
    // prev() {
    //   console.log("TODO: unhold");
    //   this.unHoldCabins();
    //   return true;
    // },
    // unHoldCabins() {
    //   this.loading++;
    //   const rooms = this.run("rooms");
    //   const ship = this.run("ship");
    //   this.run(
    //     "fetch",
    //     "index.php?option=com_cruise&task="+(this.run('get', 'config.task', "booking"))+".cabinUnHold",
    //     {
    //       rooms,
    //       shipCode: ship.shipCode,
    //       packageId: ship.packageId,
    //       sailDate: ship.sailDate,
    //     }
    //   );

    //   this.loading--;
    // },
    hasSenior(GUESTS) {
      if (!GUESTS) {
        return false;
      }
      const guests = GUESTS.guests;
      let senior = false;
      for (const k in guests) {
        const guest = guests[k];
        const date = new Date(
          guest.birthdayYear,
          guest.birthdayMonth - 1,
          guest.birthdayDay
        );
        if (this.age(date) > 55) {
          senior = true;
          break;
        }
      }
      return senior;
    },
    changeSenior() {
      this.loading++;
      setTimeout(() => {
        for (const k in this.userRooms) {
          const room = this.userRooms[k];
          room.senior = this.hasSenior(this.guests[k] ?? false) ? 1 : 0;
        }
        this.run("set", "forceBackCategory", true)
        this.run("set", "unholdSilent", true);
        this.run("goStepByName", "RoomGuestQuantity");
        this.loading--;
      }, 100);
    },
    age(birth) {
      const ship = this.run("ship");
      const current = new Date(ship.sailDate);
      let age = current.getFullYear() - birth.getFullYear();
      if (
        current.getMonth() < birth.getMonth() ||
        (current.getMonth() === birth.getMonth() &&
          current.getDate() < birth.getDate())
      ) {
        age--;
      }
      return age;
    },
    validate(roomIndex, guestIndex, scrollToError) {
      let error = false;
      for (const rIndex in this.guests) {
        if (roomIndex != undefined && roomIndex != rIndex) {
          continue;
        }
        const roomGuest = this.guests[rIndex];
        for (const index in roomGuest.guests) {
          if (guestIndex != undefined && guestIndex != index) {
            continue;
          }
          const errorKey = rIndex + "-" + index;
          const guest = roomGuest.guests[index];
          this.errors[errorKey] = {};
          if (!guest.title.trim()) {
            this.errors[errorKey]["title"] = this.tran("GUEST_TITLE_ERROR");
          }
          if (guest.firstName.search(/[^a-zA-Z\s]/) >= 0) {
            this.errors[errorKey]["firstName"] = this.tran(
              "CHARACTERS_ONLY_ERROR"
            );
          } else if (!guest.firstName.trim() || guest.firstName.length < 2) {
            this.errors[errorKey]["firstName"] = this.tran("FIRST_NAME_ERROR");
          }
          if (guest.lastName.search(/[^a-zA-Z\s]/) >= 0) {
            this.errors[errorKey]["lastName"] = this.tran(
              "CHARACTERS_ONLY_ERROR"
            );
          } else if (!guest.lastName.trim() || guest.lastName.length < 2) {
            this.errors[errorKey]["lastName"] = this.tran("LAST_NAME_ERROR");
          }
          if (
            !guest.birthdayDay ||
            !guest.birthdayMonth ||
            !guest.birthdayYear
          ) {
            this.errors[errorKey]["birthday"] = this.tran("BIRTHDAY_ERROR");
          } else {
            // primary guest age >= 21
            const date = new Date(
              guest.birthdayYear,
              guest.birthdayMonth - 1,
              guest.birthdayDay
            );
            if (
              date.getFullYear() != guest.birthdayYear ||
              date.getMonth() != guest.birthdayMonth - 1 ||
              date.getDate() != guest.birthdayDay
            ) {
              this.errors[errorKey]["birthday"] = this.tran("BIRTHDAY_ERROR");
              guest.birthdayDay = "";
            }
            const age = this.age(date);
            // if (index == 0 && age < 21) {
            //   this.errors[errorKey]["birthday"] = this.tran(
            //     "AGE_PRIMARY_GUEST_ERROR"
            //   );
            // } else
            if (guest.type == "adult" && age < 18) {
              this.errors[errorKey]["birthday"] = this.tran("AGE_ADULT_ERROR");
            } else if (guest.type == "child" && age > 17) {
              this.errors[errorKey]["birthday"] = this.tran("AGE_CHILD_ERROR");
            }
          }
          if (!guest.citizenship.trim()) {
            this.errors[errorKey]["citizenship"] =
              this.tran("CITIZENSHIP_ERROR");
          }
          if (!guest.gender.trim()) {
            this.errors[errorKey]["gender"] = this.tran("GENDER_ERROR");
          } else {
            for (const title of this.titles) {
              if (title.value != guest.title) {
                continue;
              }
              if (title.gender == 2) {
                break;
              }
              if (
                (title.gender == 0 && guest.gender == "female") ||
                (title.gender == 1 && guest.gender == "male")
              ) {
                this.errors[errorKey]["gender"] = this.tran(
                  "TITLE_GENDER_ERROR",
                  {
                    gender: this.tran(guest.gender.toUpperCase()),
                    title: title.title,
                  }
                );
              }
            }
          }
          const phone = guest.phoneNumber.replace(/[^0-9]/g, "");
          if (
            index == 0 &&
            (!guest.phoneNumber.trim() || phone.length < 8 || !guest.phoneCode)
          ) {
            this.errors[errorKey]["phone"] = this.tran("PHONE_ERROR");
          }
          guest.phone = guest.phoneNumber
            ? "(" + guest.phoneCode + ")" + guest.phoneNumber
            : "";
          if (
            ((index == 0 && !guest.email.trim()) || guest.email.trim()) &&
            !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              guest.email
            )
          ) {
            this.errors[errorKey]["email"] = this.tran("EMAIL_ERROR");
          }

          if (Object.keys(this.errors[errorKey]).length) {
            error = true;
            this.guests[rIndex].guests[index].active = true;
            this.guests[rIndex].guests[index].complete = false;
            for (const ri in this.guests) {
              for (const i in this.guests[ri].guests) {
                if (
                  i != index &&
                  ri != roomIndex &&
                  this.guests[ri].guests[i].complete
                ) {
                  this.guests[ri].guests[i].active = false;
                }
              }
            }
          } else {
            this.guests[rIndex].guests[index].complete = true;
          }
        }
        const key21 =
          guestIndex == undefined ? rIndex + "-0" : rIndex + "-" + guestIndex;
        if (this.errors[key21]["birthday"] == undefined) {
          const minAge = this.vaccination?.age ?? (this.run('get', 'ship.minAge', 18));
          let enoughAge = false;
          for (const index in roomGuest.guests) {
            const guest = roomGuest.guests[index];
            const date = new Date(
              guest.birthdayYear,
              guest.birthdayMonth - 1,
              guest.birthdayDay
            );
            const age = this.age(date);
            if (age >= minAge) {
              enoughAge = true;
            }
          }

          if (!enoughAge) {
            this.errors[key21]["birthday"] = this.tran(
              "AGE_PRIMARY_GUEST_ERROR",
              { age: minAge }
            );
            error = true;
          }
        }
        if (error) {
          break;
        }
      }
      for (const guestRoom of this.guests) {
        let complete = true;
        for (const guest of guestRoom.guests) {
          if (!guest.complete) {
            complete = false;
            break;
          }
        }
        guestRoom.complete = complete;
      }
      if (error && scrollToError !== false) {
        this.scrollToError();
      }
      return !error;
    },
    nextGuest(roomIndex, guestIndex) {
      if (!this.validate(roomIndex, guestIndex)) {
        return;
      }
      if (roomIndex < this.guests.length - 1) {
        this.guests[roomIndex].active = false;
        for (const guest of this.guests[roomIndex].guests) {
          guest.active = false;
        }
        this.guests[roomIndex + 1].active = true;
        for (const guest of this.guests[roomIndex + 1].guests) {
          guest.active = true;
        }
        return;
      }
      if (!this.validate()) {
        return;
      }
      // let hideSummary = true;
      // for (const room of this.userRooms) {
      //   if (!room.hideSummary) {
      //     hideSummary = false;
      //     break;
      //   }
      // }
      // if(!hideSummary){

      // }
      this.run("next");
    },
    changeInput(value, index, roomIndex, key) {
      const errorKey = roomIndex + "-" + index;
      this.guests[roomIndex].guests[index][key] = value;
      if (key == "birthdayMonth") {
        this.setDays(index, roomIndex);
      }
      if (
        this.guests[roomIndex].guests[index].complete ||
        (this.errors[errorKey] && this.errors[errorKey][key])
      ) {
        this.validate(roomIndex, index, false);
      }
    },
    hideSummary(index) {
      if (typeof this.rooms[index] == "undefined") {
        this.rooms[index] = { hideSummary: false };
        return;
      }
      this.rooms[index].hideSummary = !this.rooms[index].hideSummary;
    },

    async scrollToError() {
      this.run("scrollToError");
    },
    setVaccination(value) {
      this.run("set", "vaccination", value);
    },
    showForm(guest) {
      if (!this.hadVaccination) {
        return;
      }
      guest.active = !guest.active;
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: "bottom-start",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            },
          },
        ],
      });
      return () => popper.destroy();
    },
    onchangeTitle(index, roomIndex) {
      const guest = this.guests[roomIndex].guests[index];
      for (const title of this.titles) {
        if (title.value != guest.title) {
          continue;
        }
        if (title.gender == 2) {
          break;
        }
        if (title.gender == 0) {
          guest.gender = "male";
        } else if (title.gender == 1) {
          guest.gender = "female";
        }
      }
      const errorKey = roomIndex + "-" + index;
      if (
        this.guests[roomIndex].guests[index].complete ||
        (this.errors[errorKey] &&
          (this.errors[errorKey]["title"] || this.errors[errorKey]["gender"]))
      ) {
        this.validate(roomIndex, index, false);
      }
    },
    changeSelect(index, roomIndex, key) {
      const errorKey = roomIndex + "-" + index;
      if (
        this.guests[roomIndex].guests[index].complete ||
        (this.errors[errorKey] && this.errors[errorKey][key])
      ) {
        this.validate(roomIndex, index, false);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
